
<template>
  <div>
    <div style="padding:30px; background: #FFFFFF;
    box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
    border-radius: 10px;">
      <div
        style="
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          margin-bottom: 20px;
        "
      >
        账户流水
      </div>
      <div style="display:flex;flex-wrap: wrap;">
            <div
              class="grid-content bg-purple"
              style="margin-bottom: 10px;min-width:300px;margin-right:20px;display: flex; align-items: center"
            >
              <span
                class="base-form-label"
              >
                流水号
              </span>
              <el-input placeholder="请输入流水号" v-model.trim="form.serialNo" clearable style="width: 250px">
              </el-input>
            </div>
            <!-- <div
              class="grid-content bg-purple"
              style="margin-bottom: 10px;min-width:300px;margin-right:20px;display: flex; align-items: center"
            >
              <span
                class="base-form-label"
                style="width: 100px"
              >
                流水渠道交易号
              </span>
              <el-input placeholder="请输入流水渠道交易号" v-model="form.tradeNo" clearable style="width: 250px">
              </el-input>
            </div> -->
            <div
              class="grid-content bg-purple"
              style="margin-bottom: 10px;min-width:300px;margin-right:20px;display: flex; align-items: center"
            >
              <span
                class="base-form-label"
              >
                交易渠道
              </span>
              <el-select style="width: 250px" v-model="form.payType" placeholder="请选择" clearable>
                <el-option
                  v-for="item in selectWayOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div
              class="grid-content bg-purple"
              style="margin-bottom: 10px;min-width:300px;margin-right:20px;display: flex; align-items: center"
            >
              <span
                class="base-form-label"
              >
                交易类型
              </span>
              <el-select style="width: 250px" v-model="form.tradeType" placeholder="请选择" clearable>
                <el-option
                  v-for="item in selectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div
              class="grid-content bg-purple"
              style="margin-bottom: 10px;min-width:300px;margin-right:20px;display: flex; align-items: center"
            >
              <span
                class="base-form-label"
              >
                <!-- 流水号 -->
                账单号
              </span>
              <el-input placeholder="请输入账单号" v-model.trim="form.billno" clearable style="width: 250px">
              </el-input>
            </div>
            <div class="grid-content bg-purple" style="min-width:285px">
              <span
                class="base-form-label"
              >
                交易时间
              </span>
              <el-date-picker
                style="width:250px"
                value-format="yyyy-MM-dd"
                v-model="form.tradeTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>

             <el-button
                @click="handleSearch()"
                style="margin-left: 20px;height:32px;line-height:2px;"
                type="primary"
                >查询</el-button
              >
               <el-button type="primary" style="height:32px;line-height:2px;background: white;border: 1px solid #FF4D01;color: #FF4D01;margin-left: 20px;" @click="handleClear"
        >重置</el-button>
      </div>
      <!-- <el-button 
      style="margin:36px 0 15px 0" type="primary" @click="exportData"
        >导出Excel</el-button
      > -->
      <div>
        <el-table
          align="center"
          :header-cell-style="{
            background: '#eef1f6',
            color: '#606266',
          }"
          border
          highlight-current-row
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; margin-top: 15px"
        >
          <el-table-column width="60px" align="center" label="序号" type="index">
          </el-table-column>
          <el-table-column v-for="item in title" :prop="item.prop" :key="item.prop" :label="item.label" :width="item.width?item.width:null">
            <template slot-scope="scope">
              <div>
                <span v-if="item.type === 'code'">{{item.options[scope.row[item.prop]]}}</span>
                <span v-else>{{scope.row[item.prop] ? scope.row[item.prop] : '-'}}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          style="margin-top: 20px; float: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30,40,50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <div style="clear:both"></div>


      </div>
    </div>
  </div>
</template>
<script>
import { dateFormat } from "@/assets/js/utils"
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now() && time.toLocaleDateString() !== new Date().toLocaleDateString()
        }
      },
      form: {},
      title: [
        { label: '流水号', prop: 'serialNo', width: '130px' },
        { label: '交易渠道', prop: 'payType', type: 'code', options: { WECHAT: '微信', ALIPAY: '支付宝', BALANCE: '余额', BANK: '银行转账', OTH:"其它" } },
        { label: '交易类型', prop: 'tradeType', type: 'code', options: { RECH: '充值', GIFT: '赠送', CONS: '消费', RTN: '返还' } },
        { label: '账单号', prop: 'billno', width: '130px' },
        { label: '交易时间', prop: 'tradeTime', width: '160px' },
        { label: '收支类型', prop: 'isIncome', type: 'code', options: { true: '收入', false: '支出' } },
        { label: '交易金额', prop: 'tradeAmount' },
        { label: '账户余额', prop: 'balance' },
        { label: '业务单号', prop: 'nos', width: '150px' },
        { label: '交易备注', prop: 'feeitemName' },
        { label: '资金形式', prop: 'fundsType' },
        { label: '充值账号', prop: 'openid', width: '170px' },
        { label: '交易渠道流水号', prop: 'tradeNo', width: '140px' },
      ],
      tableData: [],
      selectWayOptions: [{ value: '', label: '全部' }, { value: 'WECHAT', label: '微信' }, { value: 'ALIPAY', label: '支付宝' }, { value: 'BALANCE', label: '余额' }, { value: 'BANK', label: '银行转账' }, { value: 'OTH', label: '其它' }],
      selectOptions: [{ value: '', label: '全部' }, { value: 'RECH', label: '充值' }, { value: 'GIFT', label: '赠送' }, { value: 'CONS', label: '消费' }, { value: 'RTN', label: '返还' }, { value: 'WDRA', label: '提现' }],
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  watch: {},
  methods: {
    handleSearch() {
      this.currentPage = 1
      this.getData()
    },
    getData() {
      const data = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ...this.form,
        customerId: this.$store.state.Authorization.customerid
      }
      if (data.tradeTime && data.tradeTime.length) {
        data.startTime = data.tradeTime[0] + ' 00:00:00'
        data.endTime = data.tradeTime[1] + ' 23:59:59'
        delete data.tradeTime
      }
      
      if (data.nos) {
        let nos = data.nos
        nos = nos.replace(/\s+/g, ',') //将任意字符转换为逗号
        nos = nos.replace(/[，,,]/g, ',')
        nos = nos.split(',')
        nos = nos.filter((element, i) => {
          // console.log(element)
          return element
        })
        data.nos = nos
      } else {
        delete data.nos
      }
      this.axios
      .post('/balanceChange/getCustomerBalanceChange', data)
      .then((res) => {
        console.log(res)
        if (res.data.code === 200){
          this.tableData = res.data.data.list.map( v => {
            v.fundsType = '现金'
            v.tradeTime = v.tradeTime ? dateFormat(v.tradeTime) : ''
            return v
          })
          this.total = res.data.data.total
        } else {
          this.tableData = []
          this.$message.error(res.data.message)
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      console.log(val)
      this.currentPage = val
      this.getData()
    },
    // 清空
    handleClear(){
      this.form = {}
      this.handleSearch()
    },
    // enter回车搜索
    enterSearch(){
      document.onkeydown = e => {
        if(e.keyCode == 13){
          this.handleSearch()
        }
      }
    },
  },
  created() {
    this.enterSearch()
  },

  mounted() {
    this.handleSearch()
  }
}
</script>
<style lang="less" scoped>
.grid-content {
  font-size: 0;
}
.base-form-label {
  display: inline-block;
  min-width: 60px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: right;
  margin-right: 20px;
}

/deep/.el-pagination__total {
  line-height: 36px !important;
}

.tableBorderMy {
  border: 1px solid #e7e7e7;
}
.tableBorderMyBtn {
  border-bottom: 1px solid #e7e7e7;
}
// .table-content-item {
//   line-height: 20px;
//   padding: 10px 5px;
// }
.myCursor {
  cursor: pointer;
}

/deep/ .el-form-item{
  margin-bottom: 8px;
  line-height: 28px;
}

/deep/ .el-input__inner{
  height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/billType/customerAmonutBalance.vue